/**
 * Sidebar entries the platform feature contributes — a contribution file the
 * shell merges into the route registry; nothing self-registers. Permissions
 * are the canonical strings from openapi/generated/route_policy.gen.go.
 */
import { Bell, CheckCheck, MapPin, ScrollText, UserCog } from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const platformNavEntries: NavEntry[] = [
  {
    path: "/account",
    labelKey: "platform.nav.account",
    icon: UserCog,
  },
  {
    path: "/admin/approvals",
    labelKey: "platform.nav.approvals",
    icon: CheckCheck,
    permission: "platform.approval.read",
  },
  {
    path: "/admin/notifications",
    labelKey: "platform.nav.notifications",
    icon: Bell,
    permission: "platform.notification.read",
  },
  {
    path: "/admin/branches",
    labelKey: "platform.nav.branches",
    icon: MapPin,
    permission: "platform.branch.read",
  },
  {
    path: "/admin/audit-log",
    labelKey: "nav.auditLog",
    icon: ScrollText,
    permission: "platform.audit.read",
  },
];
